import React from 'react'

export default function ToggleSwitch({ 
  checked = false, 
  onCheckedChange, 
  id,
  className = "" 
}) {
  const handleClick = () => {
    if (onCheckedChange) {
      onCheckedChange(!checked)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault()
      handleClick()
    }
  }

  return (
    <div
      id={id}
      role="switch"
      aria-checked={checked}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`cursor-pointer ${className}`}
      style={{
        width: 33,
        height: 18,
        position: 'relative',
        outline: 'none'
      }}
    >
      {/* Background track */}
      <div 
        style={{
          width: 33,
          height: 18,
          left: 0,
          top: 0,
          position: 'absolute',
          background: checked ? 'var(--blue-500, #3B82F6)' : 'var(--neutral-200, #E5E5E5)',
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
          borderRadius: 12,
          transition: 'background-color 0.2s ease'
        }}
      />
      {/* Thumb */}
      <div 
        style={{
          width: 16,
          height: 16,
          left: checked ? 16 : 1,
          top: 1,
          position: 'absolute',
          background: 'var(--white, white)',
          borderRadius: 9999,
          transition: 'left 0.2s ease'
        }}
      />
    </div>
  )
}